import styled from 'styled-components/macro';
import {Tooltip} from '@mui/material';

const StyledTooltips = styled(Tooltip)``;

export {StyledTooltips};
